<template>
  <div class="decorate content lg flex-box vertical" v-if="add">
    <Decorate key="template-decorate" @close="handleClose" />
  </div>
  <div class="template content lg flex-box vertical" v-else>
    <div class="content-title">
      <div class="content-title-text">模板库</div>
      <div class="content-title-btn">
        <a-button type="primary" icon="plus-circle" @click="addTemp()">
          新增模板
        </a-button>
      </div>
    </div>
    <div class="gap"></div>
    <div class="icon-area flex-grow scroll-area">
      <ul class="temp-list" v-if="list && list.length > 0">
        <li class="temp-item" v-for="(item, index) in list" :key="item.id">
          <div class="temp-name">{{ item.name }}</div>
          <div class="temp-btn">
            <a-icon
              type="form"
              class="icon-edit-outline temp-btn-item"
              @click="editTemp(index)"
            />
            <a-icon
              type="delete"
              class="icon-delete temp-btn-item"
              @click="delTemp(index)"
            />
          </div>
        </li>
      </ul>
      <div class="no-data" v-else-if="list">暂无模板，请添加模板</div>
    </div>
  </div>
</template>

<script>
import Decorate from "./Decorate.vue";

export default {
  name: "Template",
  components: {
    Decorate,
  },
  data() {
    return {
      add: false,
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let url = "/activity/activity-temp?page=1&pageSize=1000";
      this.$axios({ url }).then((res) => {
        this.list = res.data;
      });
    },
    addTemp() {
      // this.$router.push({
      //   name: "ActivityDecorate",
      //   params: { type: "temp", id: this.activity.id },
      // });
      this.add = true;
    },
    handleClose(update) {
      update && this.getList();
      this.add = false;
    },
    editTemp(index) {
      this.index = index;
      let item = this.list[index];
      let conf = { id: item.id, name: item.name };
      // try {
      //   let temp = JSON.parse(item.temp_config);
      //   conf = Object.assign(conf, temp);
      // } catch (e) {
      //   console.log(e);
      // }
      // this.conf = conf;

      this.$router.push({
        name: "ActivityDecorate",
        params: { id: conf.id },
        query: { type: "temp" },
      });
    },
    delTemp(index) {
      let item = this.list[index];
      this.$confirm({
        title: "提示",
        content: "删除之后不可恢复，确认删除此模板吗？",
        onOk: () => {
          let url = "/activity/activity-temp/" + item.id;
          this.$axios({
            url,
            method: "DELETE",
          }).then(() => {
            this.$message.success("删除成功");
            this.getList();
          });
        },
        onCancel: () => {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.decorate {
  padding: 0;
}
.template {
  --border-color: #dcdfe6;
  --border: 1px solid var(--border-color);
  --back-light-color: #eee;
}
.temp-item {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-left: 20px;
  margin-bottom: 20px;
  width: 200px;
  height: 100px;
  border: var(--border);
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  line-height: 100px;
  &:hover {
    .temp-btn {
      display: flex;
    }
  }
}
.temp-btn {
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 24px;
  color: var(--back-light-color);
}
.temp-btn-item {
  cursor: pointer;
}
.icon-delete {
  margin-left: 20px;
}
</style>
